import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/pecuaria/cadastro/raca' };
/////////////////////////////////////////////////////////////////////////////////

export function createAnimalRacaCadastro(payload) {
  return httpService.post(args, payload);
}

export function updateAnimalRacaCadastro(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listAnimalRacaCadastro(param) {
  return httpService.get({...args, args: param});
}

export function findAnimalRacaCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function deleteAnimalRacaCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

